import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MortgageOffersHeaderRow.css';

export const MortgageOffersHeaderRow: React.FC = () => {
  return (
    <div className={styles['row']}>
      <div className={styles['main']}>
        <UIText2 color="gray40_100">Банки и застройщики</UIText2>
      </div>
      <div className={styles['rate']}>
        <UIText2 color="gray40_100">Ставка</UIText2>
      </div>
      <div className={styles['sum']}>
        <UIText2 color="gray40_100">Сумма</UIText2>
      </div>
      <div className={styles['term']}>
        <UIText2 color="gray40_100">Срок</UIText2>
      </div>
      <div className={styles['payment']}>
        <UIText2 color="gray40_100">Ежемесячный платёж</UIText2>
      </div>
    </div>
  );
};
